import { Center, Text } from '@chakra-ui/react';

export default function None() {
  return (
    <Center py={3} opacity="0">
      <Text w="1.4rem">0</Text>
    </Center>
  );
}
